module.exports = __webpack_public_path__ + "static/media/ее.a650651d.png";